import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useLocation, useNavigate } from "react-router";
import Select from "react-select";
import { City } from "country-state-city";
import debounce from "lodash.debounce"; // Helps optimize search
import "../styles/contactStyles.css";
import { trackEvent } from "../utils/ga";
import { contactPageSchema } from "../validatorSchema/formSchema";
import api from "../utils/axiosUtils";
import { Formik, Form, Field, ErrorMessage } from "formik";

const BaggageForm2 = () => {
  const isUAEPath = window.location.pathname.startsWith("/uae");
  const currentLocation = useLocation();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  const basePath = currentLocation.pathname.startsWith("/uae") ? "/uae" : "/";
  const map = isUAEPath
    ? "https://timewatch.co.in/images/DubaiMap.png"
    : "https://timewatch.co.in/images/OurPresence.png";

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    // location: "",
    message: "",
  });

  const [filteredCities, setFilteredCities] = useState([]);
  const [inputValue, setInputValue] = useState("");

  // Fetch cities dynamically based on search input
  const fetchCities = debounce((input) => {
    if (!input) return;

    const allCities = City.getAllCities();
    const filtered = allCities
      .filter((city) => city.name.toLowerCase().startsWith(input.toLowerCase()))
      .slice(0, 10) // Limit to first 10 results to avoid lag
      .map((city) => ({
        label: `${city.name}, ${city.stateCode}, ${city.countryCode}`,
        value: city.name,
      }));

    setFilteredCities(filtered);
  }, 300); // Debounce to prevent excessive calls

  const handleInputChange = (value) => {
    setInputValue(value);
    fetchCities(value);
  };

  const handleLocationChange = (selectedOption) => {
    setFormData({
      ...formData,
      location: selectedOption,
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    if (error) setError("");
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    setSubmitting(true);

    console.log("Form values:", values);
    try {
      await api.post("/baggage-scanner", values);

      setSubmitting(false);

      navigate("/thank-you");
    } catch (error) {
      console.error("Error:", error);
      setSubmitting(false);
    }
  };

  return (
    <div className="container my-5">
      <div className="form p-2 p-md-0">
        <div className="row">
          <div className="col-md-6">
            <div className="d-flex flex-column align-items-start">
              <h2
                className="text-danger mb-4 mt-2"
                style={{ fontWeight: "bold" }}
              >
                Get in Touch with Us!
              </h2>
            </div>

            <Formik
              initialValues={{
                name: "",
                email: "",
                mobile: "",
                location: null,
                message: "",
              }}
              validationSchema={contactPageSchema}
              onSubmit={handleSubmit}
            >
              {({ setFieldValue, values, isSubmitting }) => (
                <Form>
                  <div className="form-group mb-3">
                    <label htmlFor="name">
                      Name<span style={{ color: "#f14144" }}>*</span>
                    </label>
                    <Field
                      name="name"
                      className="form-control"
                      placeholder="e.g., John Doe"
                      style={{ border: "2px solid grey", borderRadius: "50px" }}
                    />
                    <ErrorMessage
                      name="name"
                      component="div"
                      className="text-danger"
                    />
                  </div>
                  <div className="form-group mb-3">
                    <label htmlFor="mobile">
                      Contact Number<span style={{ color: "#f14144" }}>*</span>
                    </label>
                    <Field
                      name="mobile"
                      className="form-control"
                      placeholder="e.g., 9876543210"
                      style={{ border: "2px solid grey", borderRadius: "50px" }}
                    />
                    <ErrorMessage
                      name="mobile"
                      component="div"
                      className="text-danger"
                    />
                  </div>

                  <div className="form-group mb-3">
                    <label htmlFor="email">
                      Email
                      {/* <span style={{ color: "#f14144" }}>*</span> */}
                    </label>
                    <Field
                      name="email"
                      className="form-control"
                      placeholder="e.g., john@mail.com"
                      style={{ border: "2px solid grey", borderRadius: "50px" }}
                    />
                    <ErrorMessage
                      name="email"
                      component="div"
                      className="text-danger"
                    />
                  </div>


                  {/* <div className="form-group mb-3">
                    <label htmlFor="location">
                      Location<span style={{ color: "#f14144" }}>*</span>
                    </label>
                    <Select
                      name="location"
                      options={filteredCities}
                      value={values.location}
                      onChange={(option) => setFieldValue("location", option)}
                      onInputChange={(value) => fetchCities(value)}
                      placeholder="Search your city..."
                      isSearchable
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          border: "2px solid grey",
                          borderRadius: "50px",
                        }),
                      }}
                    />
                    <ErrorMessage
                      name="location"
                      component="div"
                      className="text-danger"
                    />
                  </div> */}

                  <div className="form-group mb-3">
                    <label htmlFor="message">
                      Message
                      {/* <span style={{ color: "#f14144" }}>*</span> */}
                    </label>
                    <Field
                      as="textarea"
                      name="message"
                      className="form-control"
                      rows="4"
                      placeholder="Write to us"
                      style={{ border: "2px solid grey", borderRadius: "5px" }}
                    />
                    <ErrorMessage
                      name="message"
                      component="div"
                      className="text-danger"
                    />
                  </div>

                  <button
                    type="submit"
                    className="btn btn-danger btn-block fw-bold"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Submitting..." : "Get in Touch"}
                  </button>
                </Form>
              )}
            </Formik>
          </div>

          <div className="col-md-6 d-none d-md-flex justify-content-center align-items-center">
            <img src={map} alt="Our Presence" className="img-fluid rounded" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BaggageForm2;
